// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audience-bar-chart-container .chart-section-overview {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  padding: 24px 18px 10px 18px !important;
  margin-top: 14px !important;
  margin-bottom: 0 !important;
  min-height: auto;
}

.chart-header-audience {
  margin-bottom: 6px;
  text-align: left;
}

.chart-main-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin-bottom: 20px;
}

.audience-bar-chart-container .chart-pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 2px;
}

.audience-bar-chart-container .chart-pagination-wrapper .custom-pagination {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/layouts/Engagements/Audience/AudiencePage/AudienceChart.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".audience-bar-chart-container .chart-section-overview {\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  background: #fff;\n  padding: 24px 18px 10px 18px !important;\n  margin-top: 14px !important;\n  margin-bottom: 0 !important;\n  min-height: auto;\n}\n\n.chart-header-audience {\n  margin-bottom: 6px;\n  text-align: left;\n}\n\n.chart-main-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: \"opensans\", sans-serif;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\n.audience-bar-chart-container .chart-pagination-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 2px;\n}\n\n.audience-bar-chart-container .chart-pagination-wrapper .custom-pagination {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
